import { Options } from 'axios-hooks';
import { useAppAxios } from '/shared/api/axios';
import { ErrorResponse, TemplateResponse } from '/shared/api/type';
import { IProject } from '../model/type/project';

export function useGetProjects(options?: Options) {
  return useAppAxios<TemplateResponse<IProject[]>, null, ErrorResponse>(`/project`, options);
}
